import { useTranslation } from "react-i18next";
import { Col } from "../../common-ui/components/grid/Col";
import { Row } from "../../common-ui/components/grid/Row";
import { Space } from "../../common-ui/components/space/Space";
import { useImageData } from "../../hooks/useImageData";
import { usePageErrors } from "../errors/PageErrorContext";
import { SummitScreenButton } from "../SummitScreenButton";
import { APIError } from "../../hooks/useErrorMessageMapping";

type EodIframeFooterProps = {
  onLoadAndClose?: () => void;
  api_key?: string;
  personalization_id?: string
};

export const EodIframeFooter: React.FC<EodIframeFooterProps> = ({
  api_key,
  personalization_id
}) => {
  const { mapAndSetErrors } = usePageErrors()

  const { t } = useTranslation()
  // Callback function to handle the success of image data fetch
  const handleImageDataSuccess = (data: any) => {
    // Check if melco_machine_callback function exists on the global window object
    if (typeof window.melco_machine_callback === 'function') {
      window.melco_machine_callback(data);  // Call the parent app's melco_machine_callback function with the data
    } else {
      const errorInfo: APIError[] = [{
        "key": "missing_callback",
        "source": "missing_callback",
        "message": t("error.melcoMachineCallbackMissing")
      }]
      mapAndSetErrors(errorInfo)
      //alert(t("error.melcoMachineCallbackMissing"))
      console.error('The melco_machine_callback callback function is not defined in the parent app.');
    }
  };


  // Use the custom hook to fetch image data when the button is clicked
  const { mutate: fetchImageData, isLoading: isLoadingImage } = useImageData(api_key!, personalization_id!, handleImageDataSuccess, mapAndSetErrors);

  // Handle the button click to fetch the image data
  const handleClick = () => {
    if (personalization_id) {
      fetchImageData(); // Trigger the image data fetch
    }
  };

  // const handleCancel = () => {
  //   alert("Handle Cancel")
  //   // Check if melco_machine_callback function exists on the global window object
  //   if (typeof window.melco_machine_callback === 'function') {
  //     window.melco_machine_callback({ command: 'CLOSE' });  // Call the parent app's melco_machine_callback function with the data
  //   } else {
  //     alert("The melco_machine_callback callback function is not defined in the parent app.")
  //     console.error('The melco_machine_callback callback function is not defined in the parent app.');
  //   }
  // };

  return (
    <Row justify="end">

      <Col>
        <Space size="large">
          {/* <SummitScreenButton onClick={handleCancel}>Cancel</SummitScreenButton> */}
          <SummitScreenButton
            style={{
              cursor: isLoadingImage ? 'not-allowed' : 'pointer', // hand on hover, disabled when loading
              opacity: isLoadingImage ? 0.5 : 1, // optional: visually show it's disabled
              transition: 'opacity 0.2s',
            }}
            type="primary"
            onClick={handleClick}
          >
            {t("footer.button.title")}
          </SummitScreenButton>
        </Space>
      </Col>
    </Row>
  )
}
